import type { TourConfig } from '../../types/tour.types'

// Report Formats list. Anchors use the view's existing distinctive classes.
// The header "Create Format" button and the stats row only render once formats
// exist, so those steps are optional and skip silently when absent.
const reportFormatsTour: TourConfig = {
  id: 'report-formats',
  title: 'Export exactly the columns you need',
  module: 'Settings',
  routeName: 'ReportFormats',
  order: 17,
  autoStart: true,
  steps: [
    {
      id: 'intro',
      title: 'Build your own export templates',
      body: 'A **report format** is a reusable column layout for your downloads. Define the fields, names and order once, then apply it to any export or bulk download — no more trimming spreadsheets by hand.',
    },
    {
      id: 'create',
      target: '.rf-header__cta',
      placement: 'bottom',
      // The header button only appears once at least one format exists.
      optional: true,
      title: 'Create a new format',
      body: 'Click here to **build a format**: pick the TAMI columns you want, rename them, set their order and max lengths to match your downstream tools.',
    },
    {
      id: 'actions',
      target: '.rf-actions',
      placement: 'bottom',
      title: 'See every available column',
      body: 'Use **Download Fields** to grab the full list of TAMI columns as a CSV — a handy reference while you decide what belongs in your format.',
    },
    {
      id: 'table',
      target: '.rf-table-card',
      placement: 'top',
      title: 'Manage your formats',
      body: 'All your formats live here. **Edit** a layout, **delete** ones you no longer use, and search by name. Drafts and available formats are flagged so you always know what is ready to export.',
    },
  ],
}

export default reportFormatsTour
